export { EmbededRenderer } from './Embeded';
